import { Checks } from "@phosphor-icons/react";

import Skeleton from "common/components/ui/Skeleton";
import { formatNumber } from "common/helpers/utils";

export default function LeadsFound({
  isLoading,
  children,
}: {
  isLoading: boolean;
  children: number;
}) {
  return (
    <div className="flex items-center justify-between rounded-3xl px-4 py-2 gap-x-3 border border-purple-100 bg-purple-10 text-purple-600">
      <Checks className="text-purple-300 size-8" />
      <span className="text-button-md mr-auto">Leads found</span>
      {isLoading ? (
        <Skeleton className="h-6 w-12" />
      ) : (
        <span className="text-lg-medium">{formatNumber(children)}</span>
      )}
    </div>
  );
}
